import axios from "axios";
import Vue from "vue";
import { initCodeApi } from "../utils/getOpenid";

const AXIOS_RETRY = 1;

// 导出这个函数
export function request(config) {
  var instance = axios.create({
    baseURL: Vue.prototype.GLOBAL.ssoServer,
    timeout: config.timeout || 20000,
  });
  // 通过axios配置请求拦截器，添加token,保证拥有获取数据的权限
  instance.interceptors.request.use((config) => {
    const tokenStr = window.localStorage.getItem("token");
    if (tokenStr) {
      config.headers.token = tokenStr;
    }
    // 文件上传时不覆盖Content-Type，让axios自动设置multipart/form-data
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json; charset=UTF-8";
    }
    return config;
  });

  // 响应拦截器
  instance.interceptors.response.use(async (config) => {
    if (
      config.headers["content-type"] ===
      "application/vnd.ms-excel;charset=utf-8"
    ) {
      console.log("文件", config);
      return config;
    }
    config._retry = config._retry || 0;
    if (config.data.code === "0000006" && config._retry < AXIOS_RETRY) {
      config._retry++;
      await initCodeApi();
      const retryPromise = new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
      return retryPromise.then(() => {
        return instance(config);
      });
    }
    return config.data;
  });
  // 调用request后返回创建的axios,(返回的会是一个promise对象)
  return instance(config);
}
